import gql from 'graphql-tag';

const UPDATE_FRICTIONLESS_TAG = gql`
  mutation updateFrictionlessTag($data: UpdateFrictionlessTagInput!) {
    updateFrictionlessTag(data: $data) {
      success
      message
      tag {
        name
        path
      }
    }
  }
`;

export default UPDATE_FRICTIONLESS_TAG;
